(function() {
	let posts_container = document.querySelector('.list');
	posts_container.insertAdjacentHTML('afterend', '<div class="load-more"></div>');

	let button = document.querySelector('.load-more');
	let page = 2;
	let loading = false;
	let finish = false;

	// todo: arrumar isso
	let scrollHandling = {
		allow: true,
		reallow: function() {
			scrollHandling.allow = true;
		},
		delay: 1000
	};

	ajax_load_func();

	if(typeof breakpoint !== 'undefined'){
		if ( breakpoint.matches === false ) {
			enableSwiper();
		}
	}

	function ajax_load_func(){
		var abort_load = document.getElementsByClassName('finish-post');
		if (abort_load.length > 0) {
			finish = true;
			button.remove();
		}
		if (!finish && !loading && button.offsetTop-100 <= window.pageYOffset + window.innerHeight) {

			loading = true;
			var data = {
				action: 'ajax_load_more',
				page: page,
				query: loadmore.query,
				exclude_posts: loadmore.exclude_posts,
				loop_type: loadmore.loop_type
			};

			if(data.loop_type === "single" || data.loop_type === "home"){
				data.cat = loadmore.exclude_cat;
			}

			$.post(loadmore.url, data, function (res) {
				if (res.success) {
					$('.list').append(res.data);
					$('.list').append(button);
					page = page + 1;
					loading = false;
					if(!res.data){
						finish = true;
						button.remove();
					}
				} else {
					// console.log(res);
				}
			}).fail(function (xhr, textStatus, e) {
				// console.log(xhr.responseText);
			});
		}
	}

	document.addEventListener( 'scroll', function( event ) {
		ajax_load_func();
	});
})();
